import { Directive, input, output } from '@angular/core';

import { type NgxMaskConfig, NgxMaskDirective } from 'ngx-mask';

@Directive({
  selector: 'input[ksMask]',
  hostDirectives: [
    {
      directive: NgxMaskDirective,
      inputs: [
        'mask: ksMask',
        'dropSpecialCharacters: ksMaskDropSpecialCharacters',
        'specialCharacters: ksMaskSpecialCharacters',
        'thousandSeparator: ksMaskThousandSeparator',
        'decimalMarker: ksMaskDecimalMarker',
        'allowNegativeNumbers: ksMaskAllowNegativeNumbers',
        'separatorLimit: ksMaskSeparatorLimit',
        'showMaskTyped: ksMaskShowMaskTyped',
        'clearIfNotMatch: ksMaskClearIfNotMatch',
        'leadZeroDateTime: ksMaskLeadZeroDateTime',
        'validation: ksMaskValidation',
      ],
      outputs: ['maskFilled: ksMaskFilled'],
    },
  ],
})
export class MaskDirective {
  readonly ksMask = input<string>();
  readonly ksMaskDropSpecialCharacters = input<NgxMaskConfig['dropSpecialCharacters']>();
  readonly ksMaskSpecialCharacters = input<NgxMaskConfig['specialCharacters']>();
  readonly ksMaskThousandSeparator = input<NgxMaskConfig['thousandSeparator']>();
  readonly ksMaskDecimalMarker = input<NgxMaskConfig['decimalMarker']>();
  readonly ksMaskAllowNegativeNumbers = input<NgxMaskConfig['allowNegativeNumbers']>();
  readonly ksMaskSeparatorLimit = input<NgxMaskConfig['separatorLimit']>();
  readonly ksMaskShowMaskTyped = input<NgxMaskConfig['showMaskTyped']>();
  readonly ksMaskClearIfNotMatch = input<NgxMaskConfig['clearIfNotMatch']>();
  readonly ksMaskLeadZeroDateTime = input<NgxMaskConfig['leadZeroDateTime']>();
  readonly ksMaskValidation = input<NgxMaskConfig['validation']>();

  readonly ksMaskFilled = output<void>();
}
